import moment from 'moment';
import { fieldNames, periods } from './constants';

export const getDateRequiredRule = (message) => ({
  type: 'object',
  required: true,
  message,
});

export const getDisabledNumbers = (num) =>
  Array.from(Array(num), (_item, index) => index);

const getNewEndDate = (endTime, date) =>
  endTime.hour() === 0 ? date.clone().add(1, 'days') : date.clone();

const setFromDate = (startTime, date) =>
  date.clone().set({ hour: startTime.hour(), minute: startTime.minute() });

const setToDate = (endTime, date) => {
  const endDate = getNewEndDate(endTime, date);

  return endDate.set({
    hour: endTime.hour(),
    minute: endTime.minute(),
  });
};

export const getDates = ({ getFieldValue, time, timeString, fieldName }) => {
  let date = getFieldValue(fieldNames.date);
  let startTime = getFieldValue(fieldNames.startTime);
  let endTime = getFieldValue(fieldNames.endTime);

  let fromDate;
  let toDate;

  if (fieldName === fieldNames.date && startTime && endTime) {
    fromDate = setFromDate(startTime, time);
    toDate = setToDate(endTime, time);
  }

  if (fieldName === fieldNames.startTime && date && endTime) {
    let end;

    const currentDateString = moment().format('YYYY-MM-DD');
    const startTimeString = `${currentDateString} ${timeString}`;
    const endTimeString = `${currentDateString} ${endTime.format('HH:mm')}`;

    if (
      moment(startTimeString).isSameOrAfter(moment(endTimeString)) &&
      time.hour() !== 0 &&
      endTime.hour() !== 0
    ) {
      end =
        timeString === '23:30'
          ? time.clone().add(30, 'minutes')
          : time.clone().add(1, 'hours');
    } else {
      end = endTime;
    }

    fromDate = setFromDate(time, date);
    toDate = setToDate(end, date);
  }

  if (fieldName === fieldNames.endTime && date && startTime) {
    let start;

    if (timeString === startTime.format('HH:mm') && startTime.hour() !== 0) {
      start = time.clone().subtract(30, 'minutes');
    } else {
      start = startTime;
    }

    const end =
      time.hour() === 0 && time.minute() === 30
        ? time.clone().set({ hour: time.hour(), minute: 0 })
        : time;

    fromDate = setFromDate(start, date);
    toDate = setToDate(end, date);
  }

  return { fromDate, toDate };
};

export const setInitPeriod = (startTime, endTime) => {
  const period = Object.values(periods).find(
    ({ start, end }) => start === startTime && end === endTime
  );

  return period?.name || '';
};
